import Vue from "vue";
// amination icon
import PlaceCategoryIcon from "@/components/common/place-category-icon.vue";
import { mapState, mapMutations } from "vuex";
import { FilterParams } from "@/api/adapter.api";

export default Vue.extend({
  components: { PlaceCategoryIcon },
  computed: {
    ...mapState("data", ["selectedGenreCategoryList", "selectedGenre", "selectedFilterRadioButtons"]),
  },
  methods: {
    ...mapMutations("data", ["setSelectedGenre", "setSelectedGenreCategoryList", "setSelectedFilterRadioButtons"]),
    // save filters genre to vuex
    setFilterParams(queries: FilterParams) {
      const { vacant, favorite, genre, genreCategoryList } = queries;
      // updating
      const list = [...this.selectedFilterRadioButtons];
      if (favorite === "1" && !list.find((str: string) => str === "favorite")) {
        list.push("favorite");
      } else {
        list.filter((str: string) => str !== "favorite");
      }

      if (vacant === "1" && !list.find((str: string) => str === "vacant")) {
        list.push("vacant");
      } else {
        list.filter((str: string) => str !== "vacant");
      }
      this.setSelectedFilterRadioButtons(list);
      // update genre
      if (genre) this.setSelectedGenre(genre);
      if (genreCategoryList) {
        this.setSelectedGenreCategoryList(genreCategoryList);
      }
    },
    getFilterParams(): FilterParams {
      const params: FilterParams = {
        vacant: this.selectedFilterRadioButtons.find((radio: string) => radio === "vacant") ? "1" : undefined,
        favorite: this.selectedFilterRadioButtons.find((radio: string) => radio === "favorite") ? "1" : undefined,
        genre: this.selectedGenre,
        genreCategoryList: this.selectedGenreCategoryList,
      };
      return params;
    },
    getFilterQueries(): { [Key: string]: string } {
      let query: { [Key: string]: string } = {};
      this.selectedFilterRadioButtons.forEach((filterBtnName: string) => {
        query[filterBtnName] = "1";
      });
      //ジャンル
      if (this.selectedGenre !== undefined) {
        query = {
          ...query,
          genre: this.selectedGenre,
        };
      }

      // ジャンルのカテゴリ
      if (this.selectedGenreCategoryList !== undefined && this.selectedGenreCategoryList.length > 0) {
        query = {
          ...query,
          genreCategoryList: this.selectedGenreCategoryList.join(","),
        };
      }
      return query;
    },
    hasGenreCategory(genreCategoryName: string): boolean {
      return this.selectedGenreCategoryList !== undefined
        ? this.selectedGenreCategoryList.some((category: string) => category === genreCategoryName)
        : false;
    },
    hasSelectedFilter(filterName: string): boolean {
      const result =
        this.selectedFilterRadioButtons !== undefined
          ? this.selectedFilterRadioButtons.some((category: string) => category === filterName)
          : false;
      return result;
    },
  },
});
